import PageLoader from 'components/PageLoader';
import TransactionAllocator from 'components/TransactionAllocator';
import { Column } from 'further-ui/components/Layout';
import useTransactionTypeSelectorOptions from 'hooks/form/useTransactionTypeSelectorOptions';
import useVehicle from 'hooks/lp/data/vehicle/useVehicle';
import { useFormContext } from 'react-hook-form';
import { CapitalActionFormValues } from '../hooks/useCapitalActionForm';

type Props = {
  vehicleId: string;
};

const TransactionsReview: React.FC<Props> = ({ vehicleId }) => {
  const { vehicle } = useVehicle(vehicleId);
  const { watch, setValue } = useFormContext<CapitalActionFormValues>();

  const transactionsData = watch('transactions');

  const { transactionTypeOptions, isLoading: transactionTypesLoading } =
    useTransactionTypeSelectorOptions();

  if (!vehicle) return null;

  if (transactionTypesLoading) {
    return <PageLoader />;
  }

  if (transactionsData.length === 0) return null;

  const handleTransactionChange = (
    commitmentId: string,
    transactions: (typeof transactionsData)[number]['transactions'],
  ) => {
    const newTransactionsData = transactionsData.map((commitment) => {
      if (commitment.commitmentId === commitmentId) {
        return { ...commitment, transactions };
      }
      return commitment;
    });

    setValue('transactions', newTransactionsData);
  };

  return (
    <Column spacing="md">
      {transactionsData.map((commitmentTransactions, index) => (
        <TransactionAllocator
          title={`${commitmentTransactions.investorName} transactions`}
          transactionTypeOptions={transactionTypeOptions}
          key={index}
          transactions={commitmentTransactions.transactions.map((t) => ({
            ...t,
            ...(t.effectiveCapitalDate
              ? {
                  label: `Effective capital date: ${t.effectiveCapitalDate.toLocalDateLabel()}`,
                }
              : {}),
          }))}
          transactionCurrency={vehicle.baseCurrency}
          vehicle={vehicle}
          onChange={(transactions) => {
            handleTransactionChange(
              commitmentTransactions.commitmentId,
              transactions,
            );
          }}
          fxRate={null}
        />
      ))}
    </Column>
  );
};

export default TransactionsReview;
